import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderComponent } from './components/header/header.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { MaterialComponentsModule } from '../material/material-components.module';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { EmailNotificationsComponent } from './components/notifications/email-notifications/email-notifications.component';
import { SwitchOrganizationComponent } from '../profile/switch-oganization/switch-oganization.component';
import { UserProfileMenuComponent } from '../profile/user-profile-menu/user-profile-menu.component';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AccountInReviewComponent } from './components/account-in-review/account-in-review.component';
import { AssetRecommendationsComponent } from './components/notifications/asset-recommendations/asset-recommendations.component';
import { ViewAssetDetailsComponent } from './components/notifications/asset-recommendations/view-asset-details/view-asset-details.component';
import { SnoozeAssetRecommendationsComponent } from './components/notifications/asset-recommendations/snooze-asset-recommendations/snooze-asset-recommendations.component';

@NgModule({
  declarations: [
    HeaderComponent,
    SideNavComponent,
    EmailNotificationsComponent,
    SwitchOrganizationComponent,
    UserProfileMenuComponent,
    AccountInReviewComponent,
    AssetRecommendationsComponent,
    ViewAssetDetailsComponent,
    SnoozeAssetRecommendationsComponent,
  ],
  imports: [
    CommonModule,
    MaterialComponentsModule,
    RouterModule,
    SharedModule,
    MatDialogModule,
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ],
  exports: [HeaderComponent, SideNavComponent],
})
export class LayoutModule {}
